// Synthetic Settings fixtures; opt in explicitly in previews.
export const FIXTURE_CURRENT_AVATAR = {
  name: 'Sara',
  meta: 'your avatar · generated 2026-03-08',
  tone: 'lantern',
};

export const FIXTURE_FAMILY_AVATARS = [
  { id: 'sara', name: 'Sara', role: 'parent · you', me: true, tone: 'lantern' },
  { id: 'david', name: 'David', role: 'parent', tone: 'river' },
  { id: 'maya', name: 'Maya', role: 'kid · 9', tone: 'violet' },
  { id: 'leo', name: 'Leo', role: 'kid · 11', tone: 'moss' },
  { id: 'finn', name: 'Finn', role: 'kid · 6', tone: 'ember' },
];

// Synthetic Settings fixtures; opt in explicitly in previews.
export const FIXTURE_PROFILE_ROWS = [
  { id: 'name', label: 'Name', value: 'Sara Silva', action: { label: 'Edit', variant: 'quiet' } },
  { id: 'email', label: 'Email', value: 'sara.silva@gmail.com · verified', action: { label: 'Change', variant: 'quiet' } },
  { id: 'password', label: 'Password', value: 'Last changed 4 months ago', action: { label: 'Change password', variant: 'secondary' } },
  {
    id: 'google',
    label: 'Google account',
    value: 'Sign in with one tap; also powers Photos import',
    chip: { tone: 'moss', label: 'Google linked', google: true },
  },
];

// Synthetic Settings fixtures; opt in explicitly in previews.
export const FIXTURE_CONSENT_ROWS = [
  { id: 'terms', label: 'Terms of Service', version: 'v3.2', desc: ' · accepted 2026-01-14 by Sara', chip: { tone: 'moss', label: 'accepted' } },
  { id: 'privacy', label: 'Privacy Policy', version: 'v2.9', desc: ' · updated 2026-06-02 — re-accept needed', chip: { tone: 'gold', label: 'action needed' } },
  { id: 'data', label: "Your family's data", desc: 'Plain-language list of everything ChoreStory stores', link: { label: 'Review what we store', href: '#legal' } },
];

export const settingsFixture = {
  profileName: 'Sara', bandTitle: 'The Silva family', notifications: 3,
  currentAvatar: FIXTURE_CURRENT_AVATAR, familyAvatars: FIXTURE_FAMILY_AVATARS,
  profileRows: FIXTURE_PROFILE_ROWS, consentRows: FIXTURE_CONSENT_ROWS,
};
